/**
 * BAN の異議申し立ての欄の日本語（en.appeals.ts と同じキーを全部持つ。漏れは typecheck で落ちる）。
 * 表記の決め事は ja.ts の冒頭と同じ。
 */
import type { enAppeals } from './en.appeals';
import type { PluralMsg } from './index';

type AppealsMessages = { [K in keyof typeof enAppeals]: (typeof enAppeals)[K] extends string ? string : string | PluralMsg };

export const jaAppeals: AppealsMessages = {
  'appeals.title': 'BANの異議申し立て',
  'appeals.lead': 'BANした利用者は、アプリの中からBANの見直しを求められます（{fn}）。受け入れるとBANが解け、退けるとBANはそのままです。返事は利用者に表示されます。',
  'appeals.what': '異議申し立て',
  'appeals.none': '未回答の異議申し立てはありません。',
  'appeals.openCount': '未回答{count}件',
  'appeals.openCountMore': '未回答{count}件以上',
  'appeals.col.player': '利用者',
  'appeals.col.ban': 'BAN',
  'appeals.col.message': '申し立ての内容',
  'appeals.col.received': '受付',
  'appeals.yourReason': 'BANの理由: {reason}',
  'appeals.kind.ban': 'BAN',
  'appeals.kind.suspension': '一時停止',
  'appeals.kind.other': 'その他の制裁',
  'appeals.accept': '受け入れてBANを解く',
  'appeals.reject': '退ける',
  'appeals.acceptTitle': '異議を受け入れてBANを解きますか？',
  'appeals.rejectTitle': '異議を退けますか？',
  'appeals.acceptBody': 'BANが外れ、利用者は今のアカウントでまたログインできます。操作は操作の記録に残ります。',
  'appeals.rejectBody': 'BANはそのままです。このBANに対して、利用者はもう異議を出せません。操作は操作の記録に残ります。',
  'appeals.response': '利用者への返事',
  'appeals.responseNote': '（任意・アプリの中で利用者に表示）',
  'appeals.responsePlaceholder': '例: リプレイを確認し、BANを解除しました。ご迷惑をおかけしました。',
  'appeals.accepted': '異議を受け入れました。BANを解きました。',
  'appeals.acceptedStillBanned': '異議を受け入れました。この利用者には、ほかにも有効なBANが残っています。',
  'appeals.rejected': '異議を退けました。BANはそのままです。'
};
